import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ru-RU';
import 'element-ui/lib/theme-chalk/index.css';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import './assets/styles/element-variables.scss';
import VueTheMask from 'vue-the-mask';
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueTheMask);
Vue.use(ElementUI, { locale });

Vue.directive('format-text', {
    bind(el, binding) {
        el.innerHTML = binding.value ? (binding.value + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2') : '';
    },
    update(el, binding) {
        if (binding.value && binding.value !== binding.oldValue) {
            el.innerHTML = (binding.value + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
        }
    }
});

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.mixin({
    methods: {
        alertClass() {
            if (window.innerWidth < this.$root.desktopWidth) {
                return 'mobile';
            }
            return '';
        }
    }
});

new Vue({
    data: {
        desktopWidth: 1200
    },
    router,
    store,
    render: h => h(App)
}).$mount('#app');
